// src/constants/routes.js
export const ROUTES = {
    // public
    HOME: '/',
    ABOUT: '/about',
    CONTACT: '/contact',
    TERMS: '/terms',
    PRIVACY: '/privacy',
    REFUND: '/refund',
    FAQ: '/faq',
    COOKIES: '/cookies',
    TRACK: '/track',
    HELP: '/help',
    HELP_ARTICLE: '/help/:slug',

    // auth
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    TWO_FA: '/2fa',
    VERIFY_EMAIL: '/verify-email',
    AUTH_CALLBACK: '/auth/Callback',
    // app
    DASHBOARD: '/dashboard',
    PORTFOLIO: '/portfolio',
    ANNOUNCEMENTS: '/announcements',
    REFERRALS: '/referrals',
    NOTIFICATIONS_INBOX: '/notifications',
    CHECKOUT: '/checkout',
    // market
    MARKET: '/market',
    COIN_DETAILS: '/market/:symbol',
    WATCHLIST: '/watchlist',
    VOUCHERS_LIST: '/vouchers',
    VOUCHERS_CREATE: '/vouchers/create',
    VOUCHERS_REDEEM: '/vouchers/redeem',
    // otc
    OTC_DESK: '/otc',
    OTC_CREATE: '/otc/create',
    OTC_ORDERBOOK: '/otc/orderbook',
    OTC_QUOTES: '/otc/quotes',
    OTC_HISTORY: '/otc/history',
    OTC_COUNTERPARTIES: '/otc/counterparties',

    // wallet
    WALLETS: '/wallets',
    DEPOSIT: '/wallets/deposit',
    WITHDRAW: '/wallets/withdraw',
    TRANSFER: '/wallets/transfer',
    ADDRESS_BOOK: '/wallets/addresses',
    WALLET_DETAILS: '/wallets/:id',

    // orders
    OPEN_ORDERS: '/orders/open',
    ORDER_HISTORY: '/orders/history',
    ORDER_DETAILS: '/orders/:id',

    // transactions
    TRANSACTIONS: '/transactions',
    TRANSACTION_DETAILS: '/transactions/:id',
    INVOICES: '/invoices',

    // kyc
    KYC: '/kyc',
    KYC_UPLOAD: '/kyc/upload',
    KYC_STATUS: '/kyc/status',
    COMPLIANCE: '/compliance',
    PAYMENT_CALLBACK: '/wallet/deposit/callback',
    ORDER_CALLBACK: '/ordercallback',
    // settings
    PROFILE: '/settings/profile',
    SECURITY: '/settings/security',
    API_KEYS: '/settings/api-keys',
    NOTIFICATIONS: '/settings/notifications',
    PREFERENCES: '/settings/preferences',
    CHECKOUT_SUCCESS: '/checkout/success',
    CART: '/cart',
    API: '/api-docs',
    VOUCHERS: '/vouchers',
    // admin
    ADMIN: '/admin',
    ADMIN_USERS: '/admin/users',
    ADMIN_ORDERS: '/admin/orders',
    ADMIN_KYC: '/admin/kyc',
    ADMIN_LIQUIDITY: '/admin/liquidity',
    ADMIN_REPORTS: '/admin/reports',
    ADMIN_USER_DETAIL: '/admin/users/:id',
    ADMIN_ORDER_DETAIL: '/admin/orders/:id',
    ADMIN_PRODUCTS: '/admin/products',
    ADMIN_ANNOUNCEMENTS: '/admin/announcements',
    ADMIN_BRANDS: '/admin/brands',
    ADMIN_PRODUCT_IMAGES: '/admin/products/:id/images',
    ADMIN_AUDIT: '/admin/audit',
    ADMIN_REPORTS_ANALYTICS: '/admin/reports/analytics',
    ADMIN_SETTINGS: '/admin/settings',
    REFERRAL_LANDING: '/r/:code',
    ADMIN_TRANSLATIONS: '/admin/translations',
    ADMIN_COINS: '/admin/coins',
    ADMIN_VOUCHERS: '/admin/vouchers',
    REFERRAL_HELPERS: {
        landing: (code) => `/r/${code}`,
    },
    ADMIN_BACKUPS: '/admin/backups',
    // errors
    NOT_FOUND: '/404',
    SERVER_ERROR: '/500',
    UNAUTHORIZED: '/403',
};